// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/NewOffer/index.css
// module id = 2453
// module chunks = 0